@if (bewegung(); as bewegung) {
  <div class="flex flex-col flex-grow overflow-auto full-width h-full w-full z-[0] lg:-mt-3 relative">
    @if ((loading$ | async) === false) {
      <div class="flex flex-col w-full px-4 pt-4 -mt-2">
        <soft-artikel-header [bewegung]="bewegung" [paletteEinzelEingabe]="paletteEinzelEingabe"></soft-artikel-header>
        <div class="flex flex-row h-full gap-3">
          <button
            class="flex soft-button primary rounded items-center justify-center h-16 w-full mt-2"
            [routerLink]="['/llr-bskomm/bewegung/' + bewegung.id + '/artikeldaten-erfassung']">
            {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_PALETTE_ERSTELLEN' | translate}}
          </button>
          @if (paletten(); as paletten) {
            <button
              class="flex soft-button primary rounded items-center justify-center h-16 w-full mt-2"
              [routerLink]="['/llr-bskomm/bewegung/' + bewegung.id + '/palettenauswahl']"
              [disabled]="paletten.length === 0">
              {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_VORHANDENE_PALETTE_AUSWAEHLEN' | translate}} ({{ paletten.length }})
            </button>
          }
        </div>
      </div>
    } @else {
      <div class="p-4">
        <div class="flex flex-col pb-5 gap-2">
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex soft-card rounded w-full h-24 mb-3">
            <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
              <div class="h-4 w-20 skeleton rounded"></div>
              <div class="h-4 w-24 skeleton rounded"></div>
              <div class="h-4 w-36 skeleton rounded"></div>
            </div>
          </div>
        </div>
        <div class="flex flex-row w-full gap-3">
          <div class="flex rounded h-16 w-full skeleton" *softRepeat="2"></div>
        </div>
      </div>
    }
  </div>
}

